// Claude: AdminSellerSubscriptionSection — subscription notes + statement cards (plan values moved to edit page inline preview) 25-Apr-2026
import { Box, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { AdminSellerAPI } from "../../../Apis/adminSellerAPI";
import { useToastWrapper } from "../../../Wrapper/toastWrapper";
import { errorHandler } from "../../../Utils/handler";

interface Props {
  sellerId: string;
}

const AdminSellerSubscriptionSection = ({ sellerId }: Props) => {
  const { error } = useToastWrapper();
  const [sellerData, setSellerData] = useState<any>(null);
  const [statements, setStatements] = useState<any[]>([]);

  useEffect(() => {
    if (!sellerId) return;
    Promise.all([
      AdminSellerAPI.getSellerById(sellerId),
      AdminSellerAPI.getSellerStatements(sellerId),
    ])
      .then(([sellerRes, stmtRes]: any[]) => {
        // Claude: global interceptor wraps all responses in {data:...}; backend also wraps in {message,data:...} — need .data.data 25-Apr-2026
        setSellerData(sellerRes?.data?.data ?? null);
        setStatements(Array.isArray(stmtRes?.data?.data) ? stmtRes.data.data : []);
      })
      .catch((err: any) => error(errorHandler(err)));
  }, [sellerId]);

  if (!sellerData) return null;

  const notes: string[] = sellerData.subscriptionNotes ?? [];

  return (
    <Box>
      {/* Subscription Notes */}
      {notes.length > 0 && (
        <Box mb={3}>
          <Text fontSize="10px" fontWeight="700" color="gray.500" textTransform="uppercase" letterSpacing="wider" mb={1}>
            Subscription Notes
          </Text>
          <Box maxH="100px" overflowY="auto" fontSize="xs" color="gray.600" bg="gray.50" p={2} borderRadius="md">
            {notes.map((note: string, i: number) => (
              <Text key={i} mb={1}>{note}</Text>
            ))}
          </Box>
        </Box>
      )}

      {/* Statement table — Claude: Date | Plan Name | Amount Paid | Payment Ref | RFX Added 25-Apr-2026 */}
      <Text fontSize="10px" fontWeight="700" color="gray.500" textTransform="uppercase" letterSpacing="wider" mb={2}>
        Payment Records
      </Text>
      {statements.length === 0 ? (
        <Text fontSize="xs" color="gray.500">No payment records yet.</Text>
      ) : (
        <Box overflowX="auto">
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "11px" }}>
            <thead>
              <tr style={{ background: "#f5f5f5" }}>
                {["Date", "Plan Name", "Amount Paid", "Payment Ref", "RFX Added"].map(h => (
                  <th key={h} style={{ padding: "4px 8px", textAlign: "left", fontWeight: 600, borderBottom: "1px solid #e8e8e8", whiteSpace: "nowrap" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {statements.map((s: any, i: number) => (
                <tr key={i} style={{ borderBottom: "1px solid #f0f0f0" }}>
                  <td style={{ padding: "4px 8px", whiteSpace: "nowrap" }}>{s.date ? new Date(s.date).toLocaleDateString() : "—"}</td>
                  <td style={{ padding: "4px 8px" }}>{s.planName || "—"}</td>
                  <td style={{ padding: "4px 8px", whiteSpace: "nowrap" }}>{s.currency ? `${s.currency} ` : ""}{s.paidAmount ?? "—"}</td>
                  <td style={{ padding: "4px 8px" }}>{s.paymentReference || "—"}</td>
                  <td style={{ padding: "4px 8px" }}>{s.rfxAdded ?? "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Box>
      )}
    </Box>
  );
};

export default AdminSellerSubscriptionSection;
